// import React, { useState, useEffect } from 'react'
// import { DataGrid } from '@mui/x-data-grid'
// import { Box } from '@mui/material'
// import apiClient from '../../../clients/ApiClient'
// import io from 'socket.io-client'
// import format from 'date-fns/format'
// import moment, { duration } from 'moment-timezone'
// import { fetchLeaveToday } from '../../../services/LeaveService'

// const socket = io('https://api.asconlineportal.com', {
//     path: '/socket.io/',
//     transports: ['websocket']
// })

// const AttendanceLeaveTodayList = () => {
//     const [employees, setEmployees] = useState([])
//     const [loading, setLoading] = useState(true)

//     // Fetch DTR data from the API
//     // const fetchDtrData = async () => {
//     //     try {
//     //         const today = new Date()
//     //         const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString()
//     //         const dateEnd = new Date(
//     //             today.getFullYear(),
//     //             today.getMonth(),
//     //             today.getDate(),
//     //             23,
//     //             59,
//     //             59,
//     //             999
//     //         ).toISOString()

//     //         const attendance = {
//     //             dateStart: dateStart,
//     //             dateEnd: dateEnd
//     //         }

//     //         const response = await apiClient.get('/dtr/', {
//     //             params: attendance
//     //         })

//     //         const formattedData = response.data
//     //             .map((employee, index) => {
//     //                 const record = employee.dailyTimeRecord && employee.dailyTimeRecord[0]
//     //                 if (!record) {
//     //                     return null
//     //                 }

//     //                 return {
//     //                     id: index + 1,
//     //                     name: employee.fullName,
//     //                     timeIn: record.timeIn === null ? '-' : new Date(record.timeIn).toLocaleTimeString(),
//     //                     timeOut: record.timeOut === null ? '-' : new Date(record.timeOut).toLocaleTimeString(),
//     //                     remarks: record.remarks === null ? '-' : record.remarks
//     //                 }
//     //             })
//     //             .filter(Boolean)

//     //         setEmployees(formattedData)
//     //         setLoading(false)
//     //     } catch (error) {
//     //         console.error('Error fetching DTR data:', error)
//     //         setLoading(false)
//     //     }
//     // }

//     const fetchDtrData = async () => {
//         setLoading(true)
//         try {
//             let response = await fetchLeaveToday()
//             const dailyRecords = response || []
//             // setTotalCount(response.count || 0)
//             console.table('dailyRecords', dailyRecords)
//             const formattedData = dailyRecords.map((record, index) => ({
//                 id: record.id || index,
//                 leaveType: record.title,
//                 start: record.start,
//                 end: record.end,
//                 name: record.extendedProps.fullname,
//                 duration: record.extendedProps.duration
//             }))

//             setEmployees(formattedData)
//         } catch (error) {
//             console.error('Error fetching leave data:', error)
//         } finally {
//             setLoading(false)
//         }
//     }

//     useEffect(() => {
//         fetchDtrData()
//     }, [])

//     const columns = [
//         { field: 'name', headerName: 'Name', width: 200 },
//         { field: 'leaveType', headerName: 'Leave Type', width: 150 },
//         { field: 'start', headerName: 'Start Date', width: 150 },
//         { field: 'end', headerName: 'End Date', width: 150 },
//         { field: 'duration', headerName: 'Duration', width: 150 }
//     ]

//     return (
//         <Box sx={{ height: '75%', width: 750 }}>
//             {/* <h2 className="text-xl font-semibold mb-4">Attendance Today</h2> */}
//             <DataGrid
//                 className="bg-white"
//                 rows={employees}
//                 columns={columns.map((column) => ({
//                     ...column,
//                     headerClassName: 'header-bold'
//                 }))}
//                 pageSize={10}
//                 rowsPerPageOptions={[10]}
//                 loading={loading}
//                 disableSelectionOnClick
//                 sx={{
//                     '& .MuiDataGrid-columnHeaders': {
//                         fontWeight: 'bold'
//                     },
//                     '& .MuiDataGrid-cell': {
//                         cursor: 'default',
//                         pointerEvents: 'none'
//                     }
//                 }}
//             />
//         </Box>
//     )
// }

// export default AttendanceLeaveTodayList

import React, { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box } from '@mui/material'
import { fetchLeaveToday } from '../../../services/LeaveService'
import moment from 'moment'

const AttendanceLeaveTodayList = () => {
    const [employees, setEmployees] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchDtrData = async () => {
        setLoading(true)
        try {
            const response = await fetchLeaveToday()
            const dailyRecords = response || []

            const formattedData = dailyRecords.map((record, index) => ({
                id: record.id || index,
                leaveType: record.title,
                start: moment(record.start).format('MMM D, YYYY'),
                end: moment(record.end).format('MMM D, YYYY'),
                name: record.extendedProps.fullname,
                duration: record.extendedProps.duration
            }))

            setEmployees(formattedData)
        } catch (error) {
            console.error('Error fetching leave data:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchDtrData()
    }, [])

    const columns = [
        {
            field: 'name',
            headerName: 'Employee Name',
            width: 220,
            renderCell: (params) => <span className="text-gray-800 font-medium">{params.value}</span>
        },
        {
            field: 'leaveType',
            headerName: 'Leave Type',
            width: 160,
            renderCell: (params) => {
                const type = params.value || '-'
                const badgeColor =
                    type === 'Sick Leave'
                        ? 'bg-yellow-100 text-yellow-700'
                        : type === 'Vacation Leave'
                          ? 'bg-green-100 text-green-700'
                          : 'bg-blue-100 text-blue-700'

                return (
                    <span
                        className={`px-3 py-1 rounded-full text-sm font-semibold tracking-wide shadow-sm ${badgeColor}`}
                    >
                        {type}
                    </span>
                )
            }
        },
        {
            field: 'start',
            headerName: 'Start Date',
            width: 150,
            renderCell: (params) => <span className="text-gray-600">{params.value}</span>
        },
        {
            field: 'end',
            headerName: 'End Date',
            width: 150,
            renderCell: (params) => <span className="text-gray-600">{params.value}</span>
        },
        {
            field: 'duration',
            headerName: 'Duration',
            width: 130,
            renderCell: (params) => <span className="text-gray-700 font-medium">{params.value}</span>
        }
    ]

    return (
        <Box
            sx={{
                height: '75%',
                width: 750,
                backgroundColor: '#f9fafb',
                borderRadius: 2,
                p: 2,
                boxShadow: 2
            }}
        >
            <DataGrid
                rows={employees}
                columns={columns.map((column) => ({
                    ...column,
                    headerClassName: 'header-bold'
                }))}
                pageSize={10}
                rowsPerPageOptions={[10]}
                loading={loading}
                disableSelectionOnClick
                sx={{
                    '& .MuiDataGrid-columnHeaders': {
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        backgroundColor: '#e5e7eb',
                        color: '#1f2937'
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '0.95rem',
                        color: '#374151',
                        py: 1
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f3f4f6'
                    }
                }}
            />
        </Box>
    )
}

export default AttendanceLeaveTodayList
